export default __webpack_public_path__ + "static/media/yellow2.dd39dbaf.jpg";